export type ConvertToPdfPayload = {
  file: File
  abortController?: AbortController
  onProgress?: (progress: number) => void
}
